const typeConfigs = {
    'section': 'section',
    'questionData': 'questionData',
    'questionList': 'questionList',
    'answerData': 'answerData',
    'answerDataGeneral': 'answerDataGeneral',
    answerList: 'answerList',
} as const

export { typeConfigs }
